import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { initialState, UserFilesState } from './user-files.state';
import * as userFilesActions from './user-files.actions';

const reducer: ActionReducer<UserFilesState, Action> = createReducer(
  initialState,
  on(
    userFilesActions.getUserAssets,
    userFilesActions.getFilesOfUserDocuments,
    (state): UserFilesState => ({
      ...state,
      userAssets: [],
      filesOfDocuments: [],
      loading: true,
    })
  ),

  on(
    userFilesActions.getFilesOfUserDocumentsSuccess,
    (state, { filesOfDocuments, getOpts }): UserFilesState => ({
      ...state,
      filesOfDocuments,
      sort: { sortBy: getOpts.sortBy, sortDir: getOpts.sortDir },
      loading: false,
    })
  ),
  on(
    userFilesActions.getUserAssetsSuccess,
    (state, { userAssets, getOpts }): UserFilesState => ({
      ...state,
      userAssets,
      sort: { sortBy: getOpts.sortBy, sortDir: getOpts.sortDir },
      loading: false,
    })
  ),

  on(
    userFilesActions.getFilesOfUserDocumentsError,
    userFilesActions.getUserAssetsError,
    (state): UserFilesState => ({
      ...state,
      loading: false,
    })
  ),

  on(
    userFilesActions.downloadAsset,
    (state, { userAssetId }): UserFilesState => ({
      ...state,
      downloadingFile: userAssetId,
    })
  ),
  on(
    userFilesActions.downloadAssetSuccess,
    userFilesActions.downloadAssetError,
    (state): UserFilesState => ({
      ...state,
      downloadingFile: null,
    })
  )
);

export function userFilesReducer(state: UserFilesState, action: Action): UserFilesState {
  return reducer(state, action);
}
